export default ({ scrollTop = 0, windowHeight, elementBound = {} } = {}) => {
  const windowBottom = scrollTop + windowHeight;
  const [elementTop, elementBottom] = [
    scrollTop + elementBound.top,
    scrollTop + elementBound.bottom,
  ];

  return elementTop < windowBottom && elementBottom >= scrollTop;
};
